
import {
getOrderList,
cancelOrders,
pickCertificate
} from "@/common/js/api.js";
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Box from 'vux/src/components/box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Sticky from 'vux/src/components/sticky/index.vue'


export default {
components: {
Scroller,
Tab,
TabItem,
XHeader,
Box,
XButton,
Group,
CellBox,
Cell,
Icon,
Sticky
},
methods: {
onItemClick(v) {

let tabChange = false;
if (this.pageInfo.extInfo.status != v) {
tabChange = true;
}
if (v == 0) {
this.pageInfo.extInfo.status = undefined;
} else {
this.pageInfo.extInfo.status = v;
}
if (tabChange) {
this.refresh();
}
},
refresh() {
let self = this;
self.pageInfo.pageIndex = 1;
self.getOrderList();
},
loadMore() {
let self = this;
self.pageInfo.pageIndex++;
self.getOrderList();
},
switchTabItem(index) {

this.$vux.loading.show({
text: "loading"
});
setTimeout(() => {
this.$vux.loading.hide();
this.index01 = index;
}, 1000);
},

cancelOrders(orderId) {
let self = this;
self.currentOrderId = orderId;
this.$vux.confirm.show({

title: "提醒您",
content: "确定本次预约吗？",
onCancel() {},
onConfirm() {
cancelOrders({ data: { orderId: self.currentOrderId } }).then(
function(data) {
self.refresh();
}
);
}
});
},

getOrderList() {
let self = this;
getOrderList({ data: this.pageInfo }).then(function(data) {
self.view.firstLoad = false;
if (data.PageIndex > 1) {
self.list = self.list.concat(data.Content);
} else {
self.list = data.Content;
}
if (data.Content.length == self.pageInfo.pageSize) {
self.$refs.scroller.enablePullup();
} else {
self.$refs.scroller.disablePullup();
}
setTimeout(() => {
self.$refs.scroller.donePullup();
self.$refs.scroller.donePulldown();
}, 50);
});
}
},
mounted() {
this.getOrderList();
},
activated() {

console.log("activated");
},
data() {
return {
view: {
loading: false,
firstLoad: true
},
status: {
pullupStatus: "default",
pulldownStatus: "default"
},
pullupConfig: {
content: "上拉加载更多",
downContent: "松开进行加载",
upContent: "上拉加载更多",
loadingContent: "加载中..."
},
pulldownConfig: {
content: "下拉刷新",
downContent: "下拉刷新",
upContent: "释放刷新",
loadingContent: "加载中..."
},
pageInfo: {
pageIndex: 1,
pageSize: 10,
keyword: "",
extInfo: { status: undefined }
},
title: "我的订单",
disabled:
typeof navigator !== "undefined" &&
/iphone/i.test(navigator.userAgent) &&
/ucbrowser/i.test(navigator.userAgent),
list: []
};
}
};



// WEBPACK FOOTER //
// ./src/components/activity/yuexiu/OrderList.vue